import React from "react";
import { MenuItem, ListItemText, Checkbox, Divider } from "@mui/material";
import CustomFormControl from "features/bidding-center/Dropdown/CustomFormControl";

const AudienceMultiSelect = ({
  value = [],
  onChange,
  options = [],
  placeholder = "Select audiences",
  width = 360,
  checkedColor = "#61D5A9",
  error = "",
}) => {
  const getLabel = (v) => {
    const opt = options.find((o) => String(o.value) === String(v));
    return opt ? opt.label : v;
  };

  return (
    <CustomFormControl
      multiple
      value={value}
      onChange={(e) => {
        const next = e.target.value;
        onChange(typeof next === "string" ? next.split(",") : next);
      }}
      displayEmpty
      error={!!error}
      helperText={error || undefined}
      helperTextFontSize={"11px"}
      minWidth={`${width}px`}
      sx={{ width: `${width}px` }}
      renderValue={(selected) => {
        if (!selected || selected.length === 0) {
          return <span style={{ fontSize: "12px", color: "#bab7b7" }}>{placeholder}</span>;
        }
        const label = selected.map(getLabel).join(", ");
        return (
          <span
            style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "12px" }}
            title={label}
          >
            {label}
          </span>
        );
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: "10px",
            maxHeight: 300,
            width,
            boxShadow: "0px 4px 14px rgba(0, 0, 0, 0.12)",
          },
        },
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={String(option.value)}
          sx={{ fontFamily: "Inter", fontSize: "12px", whiteSpace: "normal", alignItems: "flex-start", paddingTop: "6px", paddingBottom: "6px" }}
        >
          <Checkbox
            size="small"
            checked={value.map(String).includes(String(option.value))}
            sx={{ padding: "2px", marginTop: "-1px", color: "#BAB7B7", "&.Mui-checked": { color: checkedColor }, "& .MuiSvgIcon-root": { height: "16px", width: "16px" } }}
          />
          <ListItemText
            primary={option.label}
            primaryTypographyProps={{ fontSize: "12px", fontFamily: "Inter", sx: { whiteSpace: "normal", wordBreak: "break-word" } }}
          />
        </MenuItem>
      ))}
      <Divider sx={{ marginTop: "4px", marginBottom: 0 }} />
    </CustomFormControl>
  );
};

export default AudienceMultiSelect;
